/** @jsx jsx */

import { Fragment as _, memo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import PDF from 'components/lib/PDF';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableBtn from 'components/lib/EditableBtn';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import Embed from 'components/lib/Embed';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import { imgPlaceholders } from 'components/lib/Image';
import mediaDefault from 'assets/Mid Rectangle.svg';
import longRectangle from 'assets/Long Rectangle.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [media, txt] = children;

    if (!includeAdditionalTextField) {
      return media;
    }

    return (
      <_>
        {media}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: !mediaContext?.isAdditionalMedia
            ? mediaDefault
            : longRectangle || imgPlaceholders[1],
        }}
      />
    );
    //
  },

  TwoColumnLayout,
  SingleColumnLayout,

  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Video,
  Audio,
  SVG,
  PDF,
  OpenPDF,
  Media,
  Embed,
  Transcript: ({ children }) => children,
};

const MultiMediaDisplay = (props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
};

export default MultiMediaDisplay;
